var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<admin-nav-bar selected=\"SetUp\"></admin-nav-bar>\n<ng-outlet></ng-outlet>";
var id1="admin/setup/setup.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/admin/setup/setup.html
// module id = 629
// module chunks = 0